export const INTEREST_DATA = "INTEREST_DATA";
export const INTEREST_ERROR_DATA = "INTEREST_ERROR_DATA";
export const INTEREST_HIDE_ERROR_DATA = "INTEREST_HIDE_ERROR_DATA";
export const INTEREST_START_LOADER = "INTEREST_START_LOADER";
export const INTEREST_STOP_LOADER = "INTEREST_STOP_LOADER";
